import type * as React from 'react';
import { createContext, useContext } from 'react';

/**
 * Provided by a modal host (e.g. XdpModalView) when an XDP page is embedded
 * inside a scroll container other than the window. Consumers (FixedPageNavigation,
 * useUpdateCtaPosition, MobileCtaModule) use this to detect embedded mode and
 * listen to the correct scroll target instead of window.
 */
type XdpEmbeddedScrollContextType = {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
};

const XdpEmbeddedScrollContext = createContext<XdpEmbeddedScrollContextType | null>(null);

export const useXdpEmbeddedScroll = () => useContext(XdpEmbeddedScrollContext);

export default XdpEmbeddedScrollContext;
